import { call, put, takeLatest } from "redux-saga/effects"
import { actionTypes, makeAction } from "../actions"
import produce from "immer"
import api from "../apiServices"
import { isNotNullOrEmpty } from "../../utils/validate"
import { ascend, path, sort } from "ramda"

export let regionSagas = [
  takeLatest(actionTypes.REGION_LOAD_COUNTRY_OPTIONS, loadCountries),
  takeLatest(actionTypes.REGION_LOAD_PROVINCE_OPTIONS, loadProvinces),
  takeLatest(actionTypes.REGION_LOAD_CITY_OPTIONS, loadCities)
]

const initialState = {
  countryOptions: [],
  assoiatedProvinceOptions: [],
  assoiatedCityOptions: []
}

const subActions = {
  SET_COUNTRY_OPTIONS: "SET_COUNTRY_OPTIONS",
  SET_PROVINCE_OPTIONS: "SET_PROVINCE_OPTIONS",
  SET_CITY_OPTIONS: "SET_CITY_OPTIONS"
}

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case actionTypes.REGION_SET_COUNTRY_OPTIONS:
      case subActions.SET_COUNTRY_OPTIONS:
        Object.assign(draft, action.payload)
        break
      case subActions.SET_PROVINCE_OPTIONS:
        Object.assign(draft, action.payload)
        break
      case subActions.SET_CITY_OPTIONS:
        Object.assign(draft, action.payload)
        break
      case actionTypes.REGION_RESET_OPTIONS:
        Object.assign(draft, action.payload.options)
        break
    }
  })

const setCountries = (countries) => makeAction(subActions.SET_COUNTRY_OPTIONS, { countryOptions: countries })
const setProvinces = (provinces) => makeAction(subActions.SET_PROVINCE_OPTIONS, { assoiatedProvinceOptions: provinces })
const setCities = (cities) => makeAction(subActions.SET_CITY_OPTIONS, { assoiatedCityOptions: cities })
const resetSelectedRegion = (payload) => makeAction(actionTypes.LANDING_RESET_SELECTED_REGION, { ...payload })

const byNameEn = ascend(path(["name", "en"]))

export function* loadCountries({ resolve, reject, payload }) {
  log("Load Countries Start")
  try {
    const params = {
      // t: `${Math.random()}`
    }
    const { data: json } = yield call(() => api.load("/countries", params))
    log(json)
    yield put(setCountries(json.results || []))
    if (resolve) resolve()
  } catch (err) {
    log(`Error ${err}`)
    if (reject) reject()
  }
  log("Load Countries End")
}

export function* loadProvinces({ payload: { countryCode } }) {
  log("Load Provinces Start")
  try {
    yield put(resetSelectedRegion({ state: {}, city: {} }))

    const params = {
      country: countryCode
      // t: `${Math.random()}`
    }
    const { data: json } = yield call(() => api.load("/provinces", params))
    log(json)
    let sortedResults = []
    if (json && isNotNullOrEmpty(json.results)) {
      sortedResults = sort(byNameEn, json.results)
    }
    yield put(setProvinces(sortedResults))
  } catch (err) {
    log(`Error ${err}`)
    yield put(setProvinces([]))
  }
  log("Load Provinces End")
}

export function* loadCities({ payload: { provinceCode } }) {
  log("Load Cities Start")
  try {
    yield put(resetSelectedRegion({ city: {} }))

    const params = {
      province: provinceCode
      // t: `${Math.random()}`
    }
    const { data: json } = yield call(() => api.load("/cities", params))
    log(json)
    let sortedResults = []
    if (json && isNotNullOrEmpty(json.results)) {
      sortedResults = sort(byNameEn, json.results)
    }
    yield put(setCities(sortedResults))
  } catch (err) {
    log(`Error ${err}`)
    yield put(setCities([]))
  }
  log("Load Cities End")
}

function log(text) {
  console.log("%c Region ", "color: white; background-color: #007aff", text)
}
